import { GET_VALIDATION_STATUS_POCKET } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Root {
    success: boolean;
    response: Response;
}

export interface Response {
    status: string;
    validation_details: ValidationDetails;
}

export interface ValidationDetails {
    account_status: string;
    registered_name: string;
}

export default (fund_account_id: string): Promise<Root> => {
    return fetchWithRefresh(
        `${GET_VALIDATION_STATUS_POCKET}?fund_account_id=${fund_account_id}`,
    ).then((res) => res.json());
};
